import { render, staticRenderFns } from "./OrganismVamosPaLaCalleCardsGrid.vue?vue&type=template&id=598a2b43&scoped=true"
import script from "./OrganismVamosPaLaCalleCardsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismVamosPaLaCalleCardsGrid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a2b43",
  null
  
)

export default component.exports